import { render, staticRenderFns } from "./SelectProductCategory.vue?vue&type=template&id=2e52afe5&"
import script from "./SelectProductCategory.vue?vue&type=script&lang=ts&"
export * from "./SelectProductCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e52afe5')) {
      api.createRecord('2e52afe5', component.options)
    } else {
      api.reload('2e52afe5', component.options)
    }
    module.hot.accept("./SelectProductCategory.vue?vue&type=template&id=2e52afe5&", function () {
      api.rerender('2e52afe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StockAdjustment/SelectProductCategory.vue"
export default component.exports